/**
 * Validate the username (email or phone number)
 * The trimmed username should be between 1 and 320 characters long
 * TODO: Add some test and improve the validation once we have the real spec
 */
function validateUsername(username: string): boolean {
  const trimmedUsername = username.trim();
  const emailMaxLength = 320;
  return trimmedUsername.length > 0 && trimmedUsername.length <= emailMaxLength;
}

export {validateUsername};
